wbApp.controller('BankAccountSelectionDialogCtrl', ['$scope',
function ($scope) {
    
    
    $scope.selectedBankAccount = {
        id: null
    };
    
    
    $scope.onBankAccountSelect = function () {
        $scope.$hide();
        $scope.onBankAccountSelected($scope.selectedBankAccount);
    }
    
    $scope.selectBankAccount = function (account) {
        $scope.selectedBankAccount = account;
    }
    
    $scope.isBankAccountSelected = function () {
        return !!$scope.selectedBankAccount.id;
    }
}]);
